import { client, errorValidation } from "./service.js";

export const submitSetScore = async function ({matchId, scores}) {
  try {
    // scores = scores.filter(v => {
    //   return !(v.scoreTeamA == 0 && v.scoreTeamB == 0)
    // })
    if (scores.length == 0) {
        return { data: null }
    }
    let setScores = ['a', 'b'].map(side => ({
      side,
      scores: scores.map((score, index) => ({
        roundNumber: index + 1,
        score: side === 'a' ? score.a : score.b,
      })),
    }));
    console.log('here scores', scores, setScores)
    let response = await client.post(`/match/update/submit-set-scores/${matchId}`, {
        setScores: setScores,
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (error) {
    console.log('here error', error.response.data)
    if (error.response.data && error.response.data.message) {
      return { error: error.response.data.message }
    }
    return errorValidation(error)
  }
}

export const startMatchService = async function ({
  matchId
}) {
  try {
    let response = await client.patch(`/match/${matchId}/start`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (error) {
    return errorValidation(error)
  }
}

export const endMatchService = async function ({
  matchId
}) {
  try {
    let response = await client.patch(`/match/${matchId}/end`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (error) {
    return errorValidation(error)
  }
}

export const woMatchService = async function ({
  matchId, matchGroupPlayerId, woReason
}) {
  try {
    let response = await client.patch(`/match/${matchId}/wo`, {
      matchGroupPlayerId, woReason
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (error) {
    return errorValidation(error)
  }
}

export const resetWalkOverService = async function ({
  matchId
}) {
  try {
    let response = await client.patch(`/match/${matchId}/reset-wo`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (error) {
    return errorValidation(error)
  }
}

export const updateEndMatchService = async function ({
  matchId, dateInfo
}) {
  try {
    let response = await client.patch(`/match/${matchId}/end-time`, {
      dateInfo
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (error) {
    return errorValidation(error)
  }
}